import {
  FaBoxOpen,
  FaCheckCircle,
  FaTimesCircle,
  FaStar,
} from "react-icons/fa";

import "./ProvisionStats.css";

function ProvisionStats({ products }) {
  const totalProducts = products.length;

  const availableProducts = products.filter(
    (item) => item.isAvailable
  ).length;

  const outOfStock = products.filter(
    (item) => Number(item.stock) <= 0
  ).length;

  const featuredProducts = products.filter(
    (item) => item.isFeatured
  ).length;

  return (
    <div className="provision-stats">

      <div className="stats-card">
        <div className="stats-icon orange">
          <FaBoxOpen />
        </div>

        <div>
          <h3>{totalProducts}</h3>
          <p>Total Products</p>
        </div>
      </div>

      <div className="stats-card">
        <div className="stats-icon green">
          <FaCheckCircle />
        </div>

        <div>
          <h3>{availableProducts}</h3>
          <p>Available</p>
        </div>
      </div>

      <div className="stats-card">
        <div className="stats-icon red">
          <FaTimesCircle />
        </div>

        <div>
          <h3>{outOfStock}</h3>
          <p>Out of Stock</p>
        </div>
      </div>

      <div className="stats-card">
        <div className="stats-icon yellow">
          <FaStar />
        </div>

        <div>
          <h3>{featuredProducts}</h3>
          <p>Featured</p>
        </div>
      </div>

    </div>
  );
}

export default ProvisionStats;